import React from 'react';
import ArrowIcon from 'assets/svgs/actions/arrow.svg';

const Breadcrumb = ({list, onClick, tab, setSelectedTab}) => (
  <div className="d-flex bg-gray4 breadcrumb-custom border w-100">
    <div
      className="d-flex align-items-center px-2 pointer"
      onClick={(e) => {
        onClick(null);
        setSelectedTab(null);
      }}
    >
      Colud
      <img
        src={ArrowIcon}
        height={15}
        className={`ml-2 ${list.length === 0 && !tab ? 'rotate' : ''}`}
        alt=""
      />
    </div>

    {tab && (
      <div
        className="d-flex align-items-center px-2 pointer"
        onClick={(e) => onClick(null)}
      >
        {tab}
        <img
          src={ArrowIcon}
          height={15}
          alt=""
          className={`ml-2 ${list.length === 0 ? 'rotate' : ''}`}
        />
      </div>
    )}

    {list.map((folder, index) => (
      <div
        key={folder._id}
        className={`d-flex align-items-center px-2 ${
          index === list.length - 1 ? '' : 'pointer'
        } `}
        onClick={(e) => onClick(folder)}
      >
        {folder.name}
        <img
          src={ArrowIcon}
          height={15}
          alt=""
          className={`ml-2 ${index === list.length - 1 ? 'rotate' : ''}`}
        />
      </div>
    ))}
  </div>
);

export default Breadcrumb;
